/* eslint-disable */
import * as Types from './schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const PaymentDataDocument = gql`
    query PaymentData {
  user {
    id
    premium {
      id
      activeOrder {
        id
        orderName
        createdAt
        planId
        isMonthly
        isYearly
        status
        firstStatus
        isSchedulingToCancellation
        isSuccessStatus
        amount
        currencyAmount
        currency {
          id
        }
        finalAmount(returnInDollars: false)
        finalAmountInCent(returnInDollars: false)
        pdfInvoiceUrl
      }
      dueDate
      customerPortalUrl(backUrl: null)
    }
    paymentHistory {
      id
      orderName
      createdAt
      planId
      isMonthly
      isYearly
      status
      firstStatus
      amount
      currencyAmount
      currency {
        id
        name
      }
      finalAmount(returnInDollars: false)
      finalAmountInCent(returnInDollars: false)
      pdfInvoiceUrl
    }
  }
}
    `;

/**
 * __usePaymentDataQuery__
 *
 * To run a query within a React component, call `usePaymentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentDataQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentDataQuery(baseOptions?: Apollo.QueryHookOptions<PaymentDataQuery, PaymentDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentDataQuery, PaymentDataQueryVariables>(PaymentDataDocument, options);
      }
export function usePaymentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentDataQuery, PaymentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentDataQuery, PaymentDataQueryVariables>(PaymentDataDocument, options);
        }
export function usePaymentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentDataQuery, PaymentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentDataQuery, PaymentDataQueryVariables>(PaymentDataDocument, options);
        }
export type PaymentDataQueryHookResult = ReturnType<typeof usePaymentDataQuery>;
export type PaymentDataLazyQueryHookResult = ReturnType<typeof usePaymentDataLazyQuery>;
export type PaymentDataSuspenseQueryHookResult = ReturnType<typeof usePaymentDataSuspenseQuery>;
export type PaymentDataQueryResult = Apollo.QueryResult<PaymentDataQuery, PaymentDataQueryVariables>;
export const TariffDataDocument = gql`
    query TariffData($coupon: String) {
  countryPrices(coupon: $coupon) {
    countryCode
    plans {
      planId
      currencies {
        currencyCode
        amount
        finalAmount
        promocodeDiscount
      }
    }
  }
}
    `;

/**
 * __useTariffDataQuery__
 *
 * To run a query within a React component, call `useTariffDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useTariffDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTariffDataQuery({
 *   variables: {
 *      coupon: // value for 'coupon'
 *   },
 * });
 */
export function useTariffDataQuery(baseOptions?: Apollo.QueryHookOptions<TariffDataQuery, TariffDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TariffDataQuery, TariffDataQueryVariables>(TariffDataDocument, options);
      }
export function useTariffDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TariffDataQuery, TariffDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TariffDataQuery, TariffDataQueryVariables>(TariffDataDocument, options);
        }
export function useTariffDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TariffDataQuery, TariffDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TariffDataQuery, TariffDataQueryVariables>(TariffDataDocument, options);
        }
export type TariffDataQueryHookResult = ReturnType<typeof useTariffDataQuery>;
export type TariffDataLazyQueryHookResult = ReturnType<typeof useTariffDataLazyQuery>;
export type TariffDataSuspenseQueryHookResult = ReturnType<typeof useTariffDataSuspenseQuery>;
export type TariffDataQueryResult = Apollo.QueryResult<TariffDataQuery, TariffDataQueryVariables>;
export const UnsubscribeDocument = gql`
    mutation unsubscribe($orderId: Int!, $planId: GraphQlSubscriptionPlan!) {
  cancelSubscription(input: {orderId: $orderId, planId: $planId})
}
    `;
export type UnsubscribeMutationFn = Apollo.MutationFunction<UnsubscribeMutation, UnsubscribeMutationVariables>;

/**
 * __useUnsubscribeMutation__
 *
 * To run a mutation, you first call `useUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeMutation, { data, loading, error }] = useUnsubscribeMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      planId: // value for 'planId'
 *   },
 * });
 */
export function useUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeMutation, UnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeMutation, UnsubscribeMutationVariables>(UnsubscribeDocument, options);
      }
export type UnsubscribeMutationHookResult = ReturnType<typeof useUnsubscribeMutation>;
export type UnsubscribeMutationResult = Apollo.MutationResult<UnsubscribeMutation>;
export type UnsubscribeMutationOptions = Apollo.BaseMutationOptions<UnsubscribeMutation, UnsubscribeMutationVariables>;
export const SubscribeDocument = gql`
    mutation subscribe($planId: GraphQlSubscriptionPlan!, $currencyCode: String, $targetCancelLink: String, $coupon: String) {
  premiumPaymentMiddleware(
    input: {currencyCode: $currencyCode, planId: $planId, targetCancelLink: $targetCancelLink, coupon: $coupon}
  )
}
    `;
export type SubscribeMutationFn = Apollo.MutationFunction<SubscribeMutation, SubscribeMutationVariables>;

/**
 * __useSubscribeMutation__
 *
 * To run a mutation, you first call `useSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeMutation, { data, loading, error }] = useSubscribeMutation({
 *   variables: {
 *      planId: // value for 'planId'
 *      currencyCode: // value for 'currencyCode'
 *      targetCancelLink: // value for 'targetCancelLink'
 *      coupon: // value for 'coupon'
 *   },
 * });
 */
export function useSubscribeMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeMutation, SubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeMutation, SubscribeMutationVariables>(SubscribeDocument, options);
      }
export type SubscribeMutationHookResult = ReturnType<typeof useSubscribeMutation>;
export type SubscribeMutationResult = Apollo.MutationResult<SubscribeMutation>;
export type SubscribeMutationOptions = Apollo.BaseMutationOptions<SubscribeMutation, SubscribeMutationVariables>;
export type PaymentDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PaymentDataQuery = { __typename?: 'Query', user: { __typename?: 'UserProxyType', id: number, premium?: { __typename?: 'UserPremiumProxyType', id: number, dueDate: string, customerPortalUrl?: string | null, activeOrder?: { __typename?: 'PremiumPaymentOrderProxyType', id: number, orderName: string, createdAt: string, planId: Types.GraphQlSubscriptionPlan, isMonthly: boolean, isYearly: boolean, status: Types.GraphQlSubscriptionStatus, firstStatus?: Types.GraphQlSubscriptionStatus | null, isSchedulingToCancellation: boolean, isSuccessStatus: boolean, amount: number, currencyAmount?: number | null, finalAmount: number, finalAmountInCent: number, pdfInvoiceUrl: string, currency: { __typename?: 'CurrencyProxyType', id: number } } | null } | null, paymentHistory?: Array<{ __typename?: 'PremiumPaymentOrderProxyType', id: number, orderName: string, createdAt: string, planId: Types.GraphQlSubscriptionPlan, isMonthly: boolean, isYearly: boolean, status: Types.GraphQlSubscriptionStatus, firstStatus?: Types.GraphQlSubscriptionStatus | null, amount: number, currencyAmount?: number | null, finalAmount: number, finalAmountInCent: number, pdfInvoiceUrl: string, currency: { __typename?: 'CurrencyProxyType', id: number, name: string } }> | null } };

export type TariffDataQueryVariables = Types.Exact<{
  coupon?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type TariffDataQuery = { __typename?: 'Query', countryPrices: { __typename?: 'CountryPricesType', countryCode: string, plans?: Array<{ __typename?: 'PlanPricesType', planId: Types.GraphQlSubscriptionPlan, currencies?: Array<{ __typename?: 'CurrencyPriceType', currencyCode: string, amount: number, finalAmount: number, promocodeDiscount?: number | null }> | null }> | null } };

export type UnsubscribeMutationVariables = Types.Exact<{
  orderId: Types.Scalars['Int']['input'];
  planId: Types.GraphQlSubscriptionPlan;
}>;


export type UnsubscribeMutation = { __typename?: 'Mutation', cancelSubscription: boolean };

export type SubscribeMutationVariables = Types.Exact<{
  planId: Types.GraphQlSubscriptionPlan;
  currencyCode?: Types.InputMaybe<Types.Scalars['String']['input']>;
  targetCancelLink?: Types.InputMaybe<Types.Scalars['String']['input']>;
  coupon?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SubscribeMutation = { __typename?: 'Mutation', premiumPaymentMiddleware: string };
